<template>
    <v-container class="max-container">
        <!--Title-->
            <v-row :class="itsResponsiveWidth ? 'titlerow--responsive' : 'titlerow'">
                <v-col class="no-pd-l titlerow__col" :cols="itsResponsiveWidth ? '6' : '5'">
                    <v-skeleton-loader class="titlerow__col__title" type="image"/>
                    <v-skeleton-loader v-show="itsResponsiveWidth" class="titlerow__col__title--responsive"  type="image"/>                    
                </v-col>
                <v-col class="no-pd-l" :cols="itsResponsiveWidth ? '8' : '7' ">
                    <v-skeleton-loader type="text"/>
                    <v-skeleton-loader v-if="itsResponsiveWidth" class="titlerow__col__subtitle" type="text"/>
                    <v-skeleton-loader v-if="itsResponsiveWidth" class="titlerow__col__subtitle--1"  type="text"/>
                </v-col>
            </v-row>
        <!--End-Title-->
        <!--Rescue-Cards-->
            <v-row class="cardrow">
                <v-col                
                cols="3"
                v-for="n in amountCard"
                :key="n"
                class="cardrow__col"         
                >    
                    <v-sheet                                       
                    class="cardrow__col__sheet card__border-radius" 
                    color="white" 
                    height="100%" 
                    elevation="3" 
                    > 
                        <v-row>
                            <v-col class="no-pd" cols="12">
                                <v-skeleton-loader class="cardrow__col__sheet__row__image" type="image"/>
                            </v-col>
                            <v-col class="cardrow__col__sheet__row__col__infocard" cols="12">
                                <v-row>
                                    <v-col cols="8">
                                        <v-skeleton-loader class="cardrow__col__sheet__row__col__infocard__row__col__header" type="image"/>
                                    </v-col>
                                </v-row>
                                <v-row class="cardrow__col__sheet__row__col__infocard__row_body">
                                    <v-col cols="10">
                                        <v-skeleton-loader type="text"/>
                                        <v-skeleton-loader type="text"/>
                                    </v-col>
                                </v-row>
                                <v-row class="cardrow__col__sheet__row__col__infocard__row__footer">
                                    <v-col cols="7">
                                        <v-skeleton-loader class="cardrow__col__sheet__row__col__infocard__row__footer__col" type="image"/>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        <!--End-Rescue-Cards-->
        <!--Evaluation-Carousel-->
            <v-row class="evaluationrow" >
                <v-col cols="11">
                    <v-row class="evaluationrow__col__row">
                        <v-col cols="5" class="evaluationrow__col__row__col"> 
                            <v-skeleton-loader type="image" /> 
                        </v-col>

                        <v-col cols="6" class="no-pd-l evaluationrow__col__row__col__1">
                            <v-row class="d-flex flex-column">
                                <v-col cols="6" class="evaluationrow__col__row__col__description"> 
                                    <v-skeleton-loader class="evaluationrow__col__row__col__description__heading"  type="image"/> 
                                </v-col>
                                <v-col cols="4" class="evaluationrow__col__row__col__description__body"> 
                                    <v-skeleton-loader type="text"/> 
                                </v-col>
                                <v-col cols="5">
                                    <v-skeleton-loader class="evaluationrow__col__row__col__description__footer" type="text"/> 
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        <!--End-Evaluation-Carousel-->
    </v-container>
</template>

<script>
export default {
    name: 'homeLoader',
    data: () => ({
        itsResponsiveWidth: false,
        amountCard:         4
    }),  
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        compareWidth() {
            ( window.innerWidth < 592) ? this.itsResponsiveWidth = true : this.itsResponsiveWidth = false;

            ( window.innerWidth < 592) ? this.amountCard = 1 : this.amountCard = 4;
        },
    }
}
</script>

<style scoped>
/*RESPONSIVENESS*/
/*END-RESPONSIVENESS*/
/*TITLE*/
     .titlerow {
        flex-direction: column;
        margin-bottom: 47px;
    }    
    .titlerow__col__title {
        max-height: 28px;
        border-radius: 12px;
    }
    /*TITLE-RESPONSIVE*/
        .titlerow--responsive {
            display: flex;
            flex: auto !important;
            align-items: center;
            flex-direction: column;
            margin-bottom: 47px;
        }
        .titlerow__col__title--responsive {
            padding: 0px;
            margin-top: 12px;
            height: 28px;
            border-radius: 12px;
        }
        .titlerow__col__subtitle {
            max-width: 267px;
        }
        .titlerow__col__subtitle--1 {
            max-width: 200px;
        }
    /*END-TITLE-RESPONSIVE*/   
/*END-TITLE*/
/*RESCUE-CARDS*/
    .cardrow__col{
        display: flex;
        flex: auto !important;
        flex-direction: row;
        min-width: 284px;
    }
    .cardrow__col__sheet {
        min-width: 268px;
    }
    .cardrow__col__sheet__row__image {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }
    .cardrow__col__sheet__row__col__infocard {
        padding: 4px;
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .cardrow__col__sheet__row__col__infocard__row__footer {
        display: flex;
        flex: auto !important;
        justify-content: center;
    }
    .cardrow__col__sheet__row__col__infocard__row__col__header {
        height: 30px;
        border-radius: 8px;
    }
    .cardrow__col__sheet__row__col__infocard__row__footer__col {
        height: 26px;
        border-radius: 12px;
    }
    .cardrow__col__sheet__row__col__infocard__row_body {
        display: flex;
        flex: auto !important;
        justify-content: center;
    }
    .cardrow {
        margin-bottom: 46px;
    }
    /*RESCUE-CARDS-RESPONSIVE*/
        @media (max-width: 592px) {
            .cardrow {
                display: flex;
                flex: auto !important;
                justify-content: center;   
            }
        }
    /*END-RESCUE-CARDS-RESPONSIVE*/
/*END-RESCUE-CARDS*/
/*EVALUATION-CAROUSEL*/
    .evaluationrow {
        display: flex;
        flex: auto !important;
        justify-content: center;
    }
    .evaluationrow__col__row  {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
    .evaluationrow__col__row__col {
        min-width: 328px;
    }
    .evaluationrow__col__row__col__description {
        min-width: 192px;
    }
    .evaluationrow__col__row__col__description__heading {
        height: 30px;
        border-radius: 12px;
    }
    .evaluationrow__col__row__col__description__body {
        min-width: 120px;
        max-width: 120px;
    }
    .evaluationrow__col__row__col__description__footer {
        min-width: 180px;
        max-width: 180px;
    }
    .evaluationrow__col__row__col__1 {
        padding: 12px;
    }
    /*EVALUATION-CAROUSEL-RESPONSIVE*/
        @media (max-width: 592px) {
           .evaluationrow__col__row {
               justify-content: center;
           }
           .evaluationrow__col__row__col__1 {
               padding-top: 0px;
           }
        }
    /*END-EVALUATION-CAROUSEL-RESPONSIVE*/
/*END-EVALUATION-CAROUSEL*/
</style>